export default __webpack_public_path__ + "static/media/fav1.e7ddc73d.jpg";